<template lang="pug">
  .wrap
    CorporationSidebar(:openSidebar="openSidebar" @toggleSidebar="toggleSidebar")

    .main
      .job-list
        .job-list-header(:class="{ 'job-list-header-fixed-sp': this.headerFixedSp }")
          CorporationSortArea(
            @searchOrderBy="searchOrderBy"
            @toggleSidebar="toggleSidebar"
          )
        .job-list-body
          CorporationColumnSortModal
          table.row-list
            CorporationTableHeader
            CorporationTableRow(
              v-for="(v, i) in index",
              :corporation="v",
              :index="i",
              :key="v.id")
        Pagination(
          :pagination="pagination"
          @selectPerPage="selectPerPage"
          @selectPage="selectPage")
    Footer
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import { ErrorMessages, perPages } from '../../constants'
  import CorporationColumnSortModal from '../parts/CorporationColumnSortModal'
  import CorporationSidebar from '../parts/CorporationSidebar'
  import CorporationSortArea from '../parts/CorporationSortArea'
  import CorporationTableHeader from '../parts/CorporationTableHeader'
  import CorporationTableRow from '../parts/CorporationTableRow'
  import Footer from '../parts/Footer'
  import Pagination from '../parts/Pagination'

  export default {
    components: {
      CorporationColumnSortModal,
      CorporationSidebar,
      CorporationSortArea,
      CorporationTableHeader,
      CorporationTableRow,
      Footer,
      Pagination,
    },
    async asyncData ({ store, route: { query } }) {
      if (!Object.keys(query).length) {
        throw new Error(ErrorMessages.NO_PARAMETER_SEARCH_CORPORATION)
      }
      if (!perPages.map(p => p.code).includes(query.perPage)) {
        throw new Error(ErrorMessages.INVALID_PER_PAGE_SEARCH_CORPORATION)
      }

      await store.dispatch('corporation/fetchIndex', query)
    },
    data () {
      return {
        headerFixedSp: false,
        openSidebar: false,
      }
    },
    mounted () {
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    },
    computed: {
      ...mapGetters('common', ['spMode']),
      ...mapState({
        meta: state => state.route.meta,
        pagination: state => state.corporation.pagination,
        index: state => state.corporation.index,
      }),
    },
    methods: {
      async searchOrderBy (target) {
        const { name, query } = this.$route
        this.$router.push({
          name,
          query: {
            ...query,
            order: target,
            page: '1',
            _t: Date.now(),
          },
        })
      },
      handleScroll () {
        if (this.spMode) {
          this.headerFixedSp = (window.scrollY > 60)
        } else {
          this.headerFixedSp = false
        }
      },
      reload ({ perPage, page } = {}) {
        const { name, query } = this.$route
        this.$router.push({
          name,
          query: {
            ...query,
            perPage: perPage || query.perPage,
            page: page || query.page,
            _t: Date.now(),
          },
        })
      },
      reloadOrSkip () {
        if (this.spMode) {
          return
        }
        this.reload()
      },
      skipReload () {},
      async selectPage (page) {
        this.reload({ page })
      },
      async selectPerPage (perPage) {
        this.updateCorporationsPerPage(perPage)
        this.reload({ perPage, page: '1' })
      },
      toggleSidebar () {
        this.openSidebar = !this.openSidebar
      },
      async updateCorporationsPerPage (corporationsPerPage) {
        this.$store.commit('common/lockGlobal')
        try {
          await this.$store.dispatch('user/updateCorporationsPerPage', { corporationsPerPage })
        } finally {
          this.$store.commit('common/unlockGlobal')
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/search/SearchCorporation.vue